import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "2f9f1bf2-a269-47d5-9eaf-d73aae7d70c7",
  solutionType: "text-or-number",
  type: "fillTheGap",
  options: {
    type: "text",
    prefixText: "Input the letter corresponding to the correct sensitivity curve:",
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "text-or-number",
  data: "a",
};
